//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'home_page_next',
  data() {
    return {
      type: '',
      obj: ""
    }
  },
  mounted() {
    this.type = this.$route.query.type;
    switch (parseInt(this.$route.query.type)) {
      case 1:
        this.$store.dispatch("titleAction", "数据库");
        break;
      case 2:
        this.$store.dispatch("titleAction", "数据结构");
        break;
    }
  },
  components: {},
  methods: {}
}



// WEBPACK FOOTER //
// ./src/components/home_page_next.vue